/** Traductions modal import Excel commandes (FR / AR) */
export const ordersExcelImportModalFr = {
  errInvalidFile: 'Veuillez sélectionner un fichier Excel valide (.xlsx ou .xls)',
  successFileLoaded: 'Fichier chargé avec succès',
  errReadFile: 'Erreur lors de la lecture du fichier',
  errRowMissingFields: 'Ligne {{row}} : champs requis manquants (fournisseur, produit, quantité ou prix).',
  errRowProductNotFound: 'Ligne {{row}} : produit "{{product}}" introuvable.',
  errRowInvalidQty: 'Ligne {{row}} : quantité "{{qty}}" invalide.',
  errRowInvalidPrice: 'Ligne {{row}} : prix unitaire "{{price}}" invalide.',
  errRowInvalidSellingPrice: 'Ligne {{row}} : prix de vente "{{price}}" invalide.',
  errRowGeneric: 'Ligne {{row}} : {{message}}',
  importSuccess: '{{count}} commandes importées avec succès.',
  importSuccessWithErrors: '{{count}} commandes importées avec succès. {{errorCount}} erreurs.',
  errImport: 'Erreur lors de l\'importation',
  title: 'Importer Commandes depuis Excel',
  chooseFile: 'Choisir un fichier Excel',
  supportsFormats: 'Supporte .xlsx et .xls',
  uploadFile: 'Télécharger Fichier',
  downloadTemplate: 'Télécharger Modèle',
  columnInfoTitle: 'Informations sur les Colonnes',
  requiredColumns: 'Colonnes requises :',
  optionalColumns: 'Colonnes optionnelles :',
  locationNote: 'Note : Stock Location doit être Principal ou Stock 1-5. Si non spécifié, Principal sera utilisé automatiquement.',
  previewTitle: 'Aperçu des Données',
  previewMore: 'Affichage de 5 sur {{total}} lignes',
  cancel: 'Annuler',
  importing: 'Importation...',
  importOrders: 'Importer Commandes'
};

export const ordersExcelImportModalAr = {
  errInvalidFile: 'يرجى اختيار ملف Excel صحيح (.xlsx أو .xls)',
  successFileLoaded: 'تم تحميل الملف بنجاح',
  errReadFile: 'خطأ في قراءة الملف',
  errRowMissingFields: 'السطر {{row}}: حقول مطلوبة مفقودة (المورد، المنتج، الكمية أو السعر).',
  errRowProductNotFound: 'السطر {{row}}: المنتج "{{product}}" غير موجود.',
  errRowInvalidQty: 'السطر {{row}}: الكمية "{{qty}}" غير صالحة.',
  errRowInvalidPrice: 'السطر {{row}}: السعر للوحدة "{{price}}" غير صالح.',
  errRowInvalidSellingPrice: 'السطر {{row}}: سعر البيع "{{price}}" غير صالح.',
  errRowGeneric: 'السطر {{row}}: {{message}}',
  importSuccess: 'تم استيراد {{count}} طلب بنجاح.',
  importSuccessWithErrors: 'تم استيراد {{count}} طلب بنجاح. {{errorCount}} أخطاء.',
  errImport: 'خطأ أثناء الاستيراد',
  title: 'استيراد الطلبات من Excel',
  chooseFile: 'اختر ملف Excel',
  supportsFormats: 'يدعم .xlsx و .xls',
  uploadFile: 'تحميل ملف',
  downloadTemplate: 'تنزيل نموذج',
  columnInfoTitle: 'معلومات الأعمدة',
  requiredColumns: 'الأعمدة المطلوبة:',
  optionalColumns: 'الأعمدة الاختيارية:',
  locationNote: 'ملاحظة: Stock Location يجب أن تكون إما Principal أو Stock 1-5. إذا لم يتم تحديدها، سيتم استخدام Principal تلقائياً.',
  previewTitle: 'معاينة البيانات',
  previewMore: 'عرض 5 من {{total}} صف',
  cancel: 'إلغاء',
  importing: 'جاري الاستيراد...',
  importOrders: 'استيراد الطلبات'
};
